import React from 'react'
import styled from 'styled-components'
import { Tag } from 'antd'
import { ConsentStatus, getStatusTagColor } from '@lmc/common/types'

interface ConsentStatusTagProps {
  status: ConsentStatus | string
  label: string
}

const ConsentStatusTag: React.FC<ConsentStatusTagProps> = ({
  status,
  label
}) => {
  const color = getStatusTagColor(status)

  return <StyledTag color={color}>{label}</StyledTag>
}

const StyledTag = styled(Tag)`
  text-transform: capitalize;
  font-weight: normal;
`

export default ConsentStatusTag
